import { Link } from "react-router-dom";
import { SiteFooter } from "../components/SiteFooter";

function LegalShell({ children }: { children: React.ReactNode }) {
  return (
    <>
      <main className="legal">
        <p style={{ marginBottom: 24 }}>
          <Link to="/" className="mono" style={{ fontSize: 13 }}>
            ← nightswarm.app
          </Link>
        </p>
        {children}
      </main>
      <SiteFooter />
    </>
  );
}

export function Privacy() {
  return (
    <LegalShell>
      <h1>Privacy</h1>
      <p className="updated">Last updated 2026-06-10 · beta</p>
      <p>
        NightSwarm is in public beta, operated by martzmakes LLC. This
        policy is intentionally short and will grow with the product.
      </p>
      <h2>What we store</h2>
      <ul>
        <li>
          Your email address, used for magic-link sign-in and nothing else.
        </li>
        <li>
          Machine metadata you enroll (machine name, capabilities, presence).
        </li>
        <li>
          Job records and session transcripts your machines stream to your
          team's archive. Transcripts are encrypted and visible only to
          members of that team.
        </li>
      </ul>
      <h2>What we don't do</h2>
      <ul>
        <li>No analytics trackers, no ad pixels, no data sales.</li>
        <li>
          No access to your code or transcripts by anyone outside your team,
          except as required to operate or debug the service with your
          consent.
        </li>
      </ul>
      <h2>Deletion</h2>
      <p>
        Delete your account from the dashboard (or email{" "}
        <a href="mailto:matt@martzmakes.com">matt@martzmakes.com</a>) and all
        associated data — machines, jobs, transcripts — is removed.
      </p>
    </LegalShell>
  );
}

export function Terms() {
  return (
    <LegalShell>
      <h1>Terms</h1>
      <p className="updated">Last updated 2026-06-10 · beta</p>
      <p>
        NightSwarm is beta software provided as-is, without warranty of any
        kind. By using it you accept that:
      </p>
      <ul>
        <li>
          Agents run on <em>your</em> machines under <em>your</em> Claude
          Code subscription — you are responsible for complying with
          Anthropic's terms and your organization's policies.
        </li>
        <li>
          You are responsible for the autonomy policies you configure and for
          reviewing agent output before it ships anywhere that matters.
        </li>
        <li>
          The service may change or break without notice during the beta.
        </li>
      </ul>
      <p>
        Questions:{" "}
        <a href="mailto:matt@martzmakes.com">matt@martzmakes.com</a>.
      </p>
    </LegalShell>
  );
}
